// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4831":"2a9cd54b","5690":"3f80fc40","9792":"e551f891"}[chunkId] + ".css";
};